import { Base2Presenter } from "core/presenter";
import { validate } from "util";
import { WebhookConstraint } from "core/constraint";
import { WebhookRepository } from "core/repository";

class WebhooksPresenter extends Base2Presenter {
  initialState() {
    return {
      webhooks: [],
      loading: true,
      editingWebhook: false,
      companyUuid: "",
      webhook: { endpoint: "", actions: [], custom_headers: [] },
      errors: {}
    };
  }

  onStart() {
    this.load();
  }

  async load() {
    const companyUuid = this.routeParams.companyUuid;

    this.enqueue({ loading: true, companyUuid });

    const result = await WebhookRepository.fetch({
      filters: [
        {
          connector: "AND",
          field: "company_uuid",
          operation: "EQ",
          value: companyUuid
        },
        { connector: "AND", field: "deleted", operation: "EQ", value: "false" }
      ]
    });

    if (result.success) {
      this.enqueue({ webhooks: result.data });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Não conseguimos buscar as webhooks para esta empresa! Tente novamente em alguns minutos."
      });
    }

    this.enqueue({ loading: false });
  }

  onAddWebhook() {
    this.enqueue({
      editingWebhook: true,
      webhook: { endpoint: "", actions: [], custom_headers: [] }
    });
  }

  onEditWebhook(webhook) {
    this.enqueue({ editingWebhook: true, webhook });
  }

  onCancelEditing() {
    this.enqueue({ editingWebhook: false });
  }

  onChangeWebhookEndpoint(value) {
    this.enqueue(vm => ({
      webhook: {
        ...vm.webhook,
        endpoint: value
      },
      errors: {}
    }));
  }

  onAddCustomHeader() {
    this.enqueue(vm => {
      const custom_headers = vm.webhook.custom_headers || [];
      return {
        webhook: {
          ...vm.webhook,
          custom_headers: [...custom_headers, { type: "", value: "" }]
        }
      };
    });
  }

  onRemoveCustomHeader(key) {
    this.enqueue(vm => {
      const newCustomHeaders = vm.webhook.custom_headers;
      newCustomHeaders.splice(key, 1);
      return {
        webhook: {
          ...vm.webhook,
          custom_headers: newCustomHeaders
        }
      };
    });
  }

  onChangeCustomHeader = (value, key, field) => {
    this.enqueue(vm => {
      const newCustomHeaders = vm.webhook.custom_headers;
      newCustomHeaders[key][field] = value;
      return {
        webhook: {
          ...vm.webhook,
          custom_headers: newCustomHeaders
        }
      };
    });
  };

  onChangeWebhookAction(key, checked) {
    this.enqueue(vm => {
      const { webhook } = vm;

      if (checked) {
        webhook.actions.push(key);
      } else {
        webhook.actions.splice(webhook.actions.indexOf(key), 1);
      }

      return { webhook };
    });
  }

  async onSave() {
    const { webhook } = this.viewModel;
    const validation = validate(webhook, WebhookConstraint, {
      fullMessages: false
    });
    const errors = {};

    if (!!validation) {
      Object.entries(validation).forEach(
        ([field, errorsLocal]) => (errors[field] = errorsLocal.join(", "))
      );
    }

    if (webhook.actions.length === 0) {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content: "Selecione ao menos uma ação."
      });

      return;
    }

    if (Object.keys(errors).length === 0) {
      this.enqueue({ loading: true });

      const companyUuid = this.routeParams.companyUuid;

      let result;

      if (webhook.uuid) {
        result = await WebhookRepository.update(webhook.uuid, webhook);
      } else {
        result = await WebhookRepository.create({
          ...webhook,
          deleted: false,
          company_uuid: companyUuid
        });
      }

      if (result.success) {
        this.load();
        this.sendNotification({
          type: "success",
          content: "Webhook criada com sucesso!"
        });
        this.enqueue({ editingWebhook: false });
      } else {
        this.sendNotification({
          type: "error",
          title: "Oooops...",
          content: `Não conseguimos ${
            webhook.uuid ? "editar" : "criar"
          } esta webhook! Tente novamente em alguns minutos.`
        });

        this.enqueue({ loading: false });
      }
    } else {
      this.enqueue({ errors });
    }
  }

  onDeleteWebhook(webhook) {
    this.sendNotification({
      type: "confirmation",
      title: "Você tem certeza?",
      content: `Tem certeza que deseja excluir esta webhook?\nEssa ação não pode ser revertida e fará com que os dados não sejam mais enviados a esta Webhook.`,
      actions: [
        {
          label: "Voltar"
        },
        {
          label: "Sim, quero excluir",
          type: "accent",
          callback: () => this.doDeleteWebhook(webhook)
        }
      ]
    });
  }

  async doDeleteWebhook(webhook) {
    this.enqueue({ loading: true });
    const result = await WebhookRepository.update(webhook.uuid, {
      deleted: true
    });

    if (result.success) {
      this.load();
    } else {
      await this.sendNotification({
        type: "error",
        title: "Oooops...",
        content:
          "Não conseguimos deletar esta webhook! Tente novamente em alguns minutos."
      });

      this.enqueue({ loading: false });
    }
  }
}

export default WebhooksPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/webhooks/webhooks.presenter.js